import { render, staticRenderFns } from "./QuizTypeOption.vue?vue&type=template&id=e7048d2e&scoped=true&"
import script from "./QuizTypeOption.vue?vue&type=script&lang=js&"
export * from "./QuizTypeOption.vue?vue&type=script&lang=js&"
import style0 from "./QuizTypeOption.vue?vue&type=style&index=0&id=e7048d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7048d2e",
  null
  
)

export default component.exports